// Shared styling helper for colors chosen in TagManager/StatusManager.
// Tag/Status colors are per-record data picked freely by the user (not design
// tokens), so they're applied as inline styles rather than Tailwind classes.
export function getColorStyle(color) {
  if (!color) return null;

  const hex = color.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.12)`,
    color,
    borderColor: `rgba(${r}, ${g}, ${b}, 0.35)`,
  };
}

export const DEFAULT_TAG_COLOR = "#6366f1";
